import { AlumniCareerStatuses } from "utils/constants";

export const getAvailability = status => {
  return {
    isAvailableForCorrection:
      status !== AlumniCareerStatuses.Active && status !== AlumniCareerStatuses.WaitingCorrection,

    isAvailableForApprove:
      status !== AlumniCareerStatuses.Active &&
      status !== AlumniCareerStatuses.Stopped &&
      status !== AlumniCareerStatuses.WaitingCorrection,

    isAvailableForReject: status !== AlumniCareerStatuses.Rejected && status !== AlumniCareerStatuses.Stopped,
  };
};
